import { createAPIProxy } from './utils/api';

/**
 * @deprecated 旧路由表仅保留兼容存量调用。
 * 新增或迁移路由请使用 `SiteRouterKey + siteRouterManager`，
 * 不要在业务代码中继续直接读取 `SITE_ROUTER.xxx`。
 * @see libs/shared/src/utils/site-router.ts
 */
export const SITE_ROUTER = createAPIProxy({
    OPEN_PLATFORM: '/open',
    OPEN_PLATFORM_UNIT: '/open#/unit/installed',
    OPEN_PLATFORM_PRIVATE_PLUGIN: '/open#/unit/private',
    OPEN_PLATFORM_MARKET: '/open#/market'
});
